import { createBrowserRouter } from "react-router-dom";
import Layout from "./Layout";
import HomePage from "./pages/HomePage";
import ChatPage from "./pages/ChatPage";
import ProfilePage from "./pages/ProfilePage";
import SearchPage from "./pages/SearchPage";
import CoursesPage from "./pages/CoursesPage";
import NavigationPage from "./pages/NavigationPage";
import NavigationDynamicPage from "./pages/NavigationDynamicPage";
import AdmissionsPage from "./pages/AdmissionsPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        element: <HomePage />,
        index: true,
      },
      {
        element: <ChatPage />,
        path: "/chat",
      },
      {
        element: <ProfilePage />,
        path: "/profile",
      },
      {
        element: <SearchPage />,
        path: "/search",
      },
      {
        element: <CoursesPage />,
        path: "/courses",
      },
      {
        element: <AdmissionsPage />,
        path: "/admissions",
      },
      {
        element: <NavigationPage />,
        path: "/navigation",
      },
      {
        element: <NavigationDynamicPage />,
        path: "/navigation/:id",
      },
    ],
  },
]);

export default router;
